import React from 'react';

import { Root } from '@radix-ui/react-navigation-menu';

import { NavigationMenu, NavigationMenuList } from 'src/registry/ui/NavigationMenu';
import { cn } from 'src/utils';

interface TabRowProps extends React.ComponentPropsWithoutRef<typeof Root> {
    children: React.ReactNode;
}

const TabRow = ({ className, children }: TabRowProps) => {
    return (
        <NavigationMenu className={cn('-mt-2', className)}>
            <NavigationMenuList>{children}</NavigationMenuList>
        </NavigationMenu>
    );
};

export default TabRow;
